import React from 'react';
import { Handshake, KeyRound, Shield } from 'lucide-react';
import { Box, Flex, Text } from 'rebass/styled-components';
import { Button } from '@getro/rombo';
import PropTypes from 'prop-types';
import { SharingIcon } from './sharingIcon';

export const EnableSharing = ({ onEnableSharing, isLoading, listName }) => {
  const items = [
    {
      title: 'Optionally let visitors request intros',
      icon: Handshake,
    },
    {
      title: 'Set a password for added privacy',
      icon: KeyRound,
    },
    {
      title: 'Not indexed by search engines',
      icon: Shield,
    },
  ];

  return (
    <Flex
      sx={{ flexDirection: 'column', alignItems: 'center', gap: '24px', mt: '40px', maxWidth: '480px', mx: 'auto' }}
    >
      <SharingIcon listName={listName} />
      <Flex sx={{ maxWidth: '400px', width: '100%', mx: 'auto', gap: '16px', flexDirection: 'column' }}>
        <Text fontSize="18px" fontWeight="600" lineHeight="24px" color="text.dark">
          Enable the shared view for external sharing
        </Text>
        {items.map((item) => (
          <Flex key={item.title} sx={{ gap: '8px', alignItems: 'center' }}>
            <Box
              sx={{
                width: '32px',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                backgroundColor: 'blue.50',
                bg: 'purple.100',
              }}
            >
              <Box as={item.icon} size="16px" sx={{ color: 'purple.400' }} />
            </Box>
            <Text color="text.main">{item.title}</Text>
          </Flex>
        ))}
      </Flex>
      <Button
        width="100%"
        maxWidth="400px"
        justifyContent="center"
        size="medium"
        loading={isLoading}
        onClick={onEnableSharing}
      >
        Enable shared view
      </Button>
    </Flex>
  );
};

EnableSharing.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onEnableSharing: PropTypes.func.isRequired,
  listName: PropTypes.string.isRequired,
};
